import { sendLiveEventPreset } from '@aelive/dds-client';
import { dds } from '../dds/ddsClient';
import { getStoredSession } from './sessionManager';

export const sendLiveEvent = async ({
  eventId,
  fixtureId,
  competitionId,
  seasonId,
  eventData,
}) => {
  if (!eventId || !fixtureId || !competitionId || !seasonId) {
    throw new Error('Missing required parameters: eventId, fixtureId, competitionId, and seasonId are required');
  }
  if (!eventData) {
    throw new Error('eventData is required');
  }

  const eventPayload = sendLiveEventPreset({
    key: {
      event_id: eventId,
      fixture_id: fixtureId,
      competition_id: competitionId,
      season_id: seasonId,
    },
    data: eventData,
  });

  await dds.http.request({
    query: eventPayload.query,
    variables: eventPayload.variables,
  });
};

// AeDrive-authoritative team_stat upsert. Reuses sendLiveEventPreset's
// passthrough now that it accepts arbitrary collections — keys on the full
// {season, competition, fixture, team, stat_type} tuple so repeated calls
// overwrite the same row.
export const upsertTeamStat = async ({
  fixtureId,
  competitionId,
  seasonId,
  teamId,
  statType,
  value,
}) => {
  if (!fixtureId || !competitionId || !seasonId || !teamId || !statType) {
    throw new Error('Missing required parameters: fixtureId, competitionId, seasonId, teamId, statType are required');
  }
  const session = getStoredSession();
  const originSite = session?.username || session?.user_name || 'aedrive';

  const payload = sendLiveEventPreset({
    collection: 'team_stat',
    key: {
      season_id: seasonId,
      competition_id: competitionId,
      fixture_id: fixtureId,
      team_id: teamId,
      stat_type: statType,
    },
    data: {
      type: statType,
      value: String(value),
    },
    originSite,
    op: 'upsert',
  });

  await dds.http.request({
    query: payload.query,
    variables: payload.variables,
  });
};



